import { useContent } from '@/services/siteData';
import { Seo } from '@/components/Seo';

export function AboutPage() {
  const { about } = useContent();
  return (
    <div className="page-fade">
      <Seo
        title="About Our Patisserie — Trade Supplier"
        description="Founded on royal-standard craft, Didier's Patisserie supplies premium French patisserie to restaurants, hotels and caterers across the UK. Meet the team behind the kitchen."
        path="/about"
      />
      <div className="page-hero" style={{ backgroundImage: `url(${about.hero})` }} />
      <div className="page-head">
        <h1>Our Story</h1>
      </div>
      <div className="story">
        {about.intro.map((t, i) => (
          <p key={i}>{t}</p>
        ))}
        {about.blocks.map((b, i) => (
          <div key={i}>
            {b.heading && <h2>{b.heading}</h2>}
            {b.img && <div className="story-img" style={{ backgroundImage: `url(${b.img})` }} />}
            {b.body.map((t, n) => (
              <p key={n}>{t}</p>
            ))}
          </div>
        ))}
        <div className="founders">
          <div className="label">The Founders</div>
          <div className="names">{about.founders}</div>
        </div>
      </div>
    </div>
  );
}
